var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarSearchBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.846 20h12.308C18.278 20 20 18.321 20 16.25V5.75C20 3.679 18.278 2 16.154 2H3.846C1.722 2 0 3.679 0 5.75v10.5C0 18.321 1.722 20 3.846 20zM1.538 5.75c0-1.243 1.034-2.25 2.308-2.25h12.308c1.274 0 2.308 1.007 2.308 2.25v10.5c0 1.243-1.034 2.25-2.308 2.25H3.846c-1.274 0-2.308-1.007-2.308-2.25V5.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.833 14h3.334c.46 0 .833-.373.833-.833V9.833A.833.833 0 007.167 9H3.833A.833.833 0 003 9.833v3.334c0 .46.373.833.833.833zm2.5-1.667H4.667v-1.666h1.666v1.666z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.23 7.5H.77A.76.76 0 010 6.75.76.76 0 01.77 6h18.46a.76.76 0 01.77.75.76.76 0 01-.77.75zM6 5c-.552 0-1-.373-1-.833V.833C5 .373 5.448 0 6 0s1 .373 1 .833v3.334C7 4.627 6.552 5 6 5zM14 5c-.552 0-1-.373-1-.833V.833c0-.46.448-.833 1-.833s1 .373 1 .833v3.334c0 .46-.448.833-1 .833z",
    fill: "currentColor"
  })));
}

export default SvgCalendarSearchBar;